module.exports = new __parcel__URL__("../treeStatus_en.88b580a5.png").toString();